import axios from "axios";
const { API_BACKEND_HOST } = process.env;

const api = axios.create({
  baseURL: `${API_BACKEND_HOST}`,
});

export interface IGroup {
  id: string;
  name: string;
  committeePackageId: string;
  committeePackageName: string;
  committeePackageActive: boolean;
  active: boolean;
  committees: {id: string; name: string; activated: boolean}[];
}

export interface IGetGroupsResponse {
  groups: IGroup[];
}

export const getGroups = async (filters?: {
  name?: string;
  committeePackageId?: string;
}) => {
  const languageId = localStorage.getItem("i18nextLng");

  const { data } = await axios.get(
    `${API_BACKEND_HOST}${languageId}/v1/Group`,
    {
      params: filters,
    }
  );

  return data;
};
